import { Box, Card, CardContent, IconButton, Rating, Tooltip, Typography } from "@mui/material"
import ViewSkillModal from "../Modals/ViewSkillModal/ViewSkillModal"
import React, { useEffect, useRef, useState } from "react"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./TopSkill.module.css"
import UsersPopup from "../UI/UserPopup/UsersPopup"
import Icn from "../UI/SharieIcn/SharieIcn"
import T from "../hooks/Language/T"
import UserSection from "../Marketplace/UserSection/UserSection"

const TopSkill = (props) => {
  const [user, setUser] = useState(null)
  const [level_color, setLevelColor] = useState("white")

  const viewRef = useRef()
  const { postData } = useApiService()

  useEffect(() => {
    postData("users/getuser", { user_name: props.skill.user_name }).then((data) => {
      setUser({ ...data?.user[0], remove_rating: true })
    })
    checkLevelColor()
  }, [props.skill])

  const checkLevelColor = () => {
    if (props.skill.level === "beginner") {
      setLevelColor("#4CAF50") // Green
    } else if (props.skill.level === "advanced") {
      setLevelColor("#FF9800") // Orange
    } else if (props.skill.level === "expert") {
      setLevelColor("#F44336") // Red
    } else {
      setLevelColor("white")
    }
  }

  const openViewSkillModal = () => {
    try {
      postData("sharie/addnotification", {
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        type: "view " + (props.skill.max_participants ? "group" : "skill"),
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
    if (viewRef.current) viewRef.current.childFunction()
  }

  return (
    <T>
      <ViewSkillModal ref={viewRef} skill={props.skill} />
      <Card className={styles.topskill_container} style={{ borderTop: "3px solid " + level_color }}>
        <CardContent>
          <Box className={styles.topskill_inner_box}>
            <div
              className={
                props.isHebrew ? styles.view_users_container_rtl : styles.view_users_container
              }
            >
              <UsersPopup skill={props.skill} />
              <Icn
                tooltip='View Skill'
                onClick={openViewSkillModal}
                label='view skill'
                icon={<VisibilityIcon style={{ color: "#80CBC4" }} />}
                className={"icon"}
              />
            </div>
            {/* Title */}
            <Typography
              variant='h5'
              component='div'
              gutterBottom
              mt='1rem'
              sx={{ textAlign: props.isHebrew ? "right" : "left" }} // Dynamically handle RTL/LTR
            >
              {props.skill?.name || "Skill Name Not Available"}
            </Typography>

            {/* Subtitle */}
            <Typography
              variant='subtitle1'
              color='text.secondary'
              gutterBottom
              sx={{ textAlign: props.isHebrew ? "right" : "left" }} // Dynamically handle RTL/LTR
            >
              {props.skill?.description || "Description Not Available"}
            </Typography>

            {/* Description */}
            <Typography
              variant='h5'
              color='text.secondary'
              paragraph
              sx={{ textAlign: props.isHebrew ? "right" : "left" }} // Dynamically handle RTL/LTR
            >
              {props.skill?.location || "Location Not Available"}
            </Typography>

            {/* Date and Status */}
            <Box display='flex' justifyContent='space-between' mt={2}>
              <Typography
                variant='body2'
                color='text.primary'
                sx={{ textAlign: props.isHebrew ? "right" : "left" }} // Dynamically handle RTL/LTR
              >
                {props.skill?.duration || "Duration Not Available"}
              </Typography>
              <Rating
                name='skill-rating'
                value={Number(props.skill?.rating) || 0}
                precision={1}
                readOnly
              />
            </Box>
          </Box>
        </CardContent>
        <UserSection user={user} top_skills={true} />
      </Card>
    </T>
  )
}

export default React.memo(TopSkill)
